import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { backendApi } from '../services/auth0-api';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [resetUrl, setResetUrl] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await backendApi.forgotPassword(email);
      setSuccess(true);
      // For demo purposes, display the reset URL
      if (response.reset_url) {
        setResetUrl(response.reset_url);
      }
    } catch (err: any) {
      setError(err.message || 'Failed to send reset email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signin-container">
      <div className="signin-form">
        <h2>Reset Your Password</h2>

        {success ? (
          <div>
            <div style={{ color: 'green', fontSize: '14px', marginBottom: '20px', padding: '15px', backgroundColor: '#d4edda', borderRadius: '4px' }}>
              ✓ If an account exists with that email, we've sent a password reset link.
              Please check your email and follow the instructions.
            </div>

            {resetUrl && (
              <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#fff3cd', borderRadius: '4px', border: '1px solid #ffc107' }}>
                <div style={{ fontWeight: 'bold', marginBottom: '10px', color: '#856404' }}>
                  Demo Mode: Reset Link
                </div>
                <div style={{ fontSize: '12px', marginBottom: '10px', color: '#856404' }}>
                  For demo purposes, here's your password reset link:
                </div>
                <a
                  href={resetUrl}
                  style={{
                    color: '#007bff',
                    textDecoration: 'underline',
                    wordBreak: 'break-all',
                    fontSize: '13px'
                  }}
                >
                  {resetUrl}
                </a>
              </div>
            )}

            <Link to="/login" style={{ color: '#007bff', textDecoration: 'underline' }}>
              Back to Sign In
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <p style={{ color: '#666', marginBottom: '20px' }}>
              Enter your email address and we'll send you a link to reset your password.
            </p>

            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />

            {error && (
              <div style={{ color: 'red', fontSize: '14px', marginBottom: '10px' }}>
                {error}
              </div>
            )}

            <button type="submit" className="continue-btn" disabled={loading}>
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>

            <div className="login-link">
              Remember your password? <Link to="/login">Sign in</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
